import { sdk } from '@grubhubprod/order-taking-client-sdk/dist/main';
import { getConfig } from 'src/utilities/config';
import { Brand } from 'src/utilities/brand';
import { isServerSide } from 'src/utilities/isServerSide';
import { isSeamlessRoute } from 'src/utilities/route-utils';

if (isServerSide()) {
  sdk.implementation.XMLHttpRequest = require('xhr2').XMLHttpRequest;
}

const config = getConfig();

export function getBrandSettingsFromUrl(): { brand: string; clientId: string } {
  const brandSettings = {
    brand: Brand.GRUBHUB,
    clientId: config.grubhubClientId,
  };

  if (isSeamlessRoute()) {
    brandSettings.brand = Brand.SEAMLESS;
    brandSettings.clientId = config.seamlessClientId;
  }

  return brandSettings;
}

export { sdk };
